import { useEffect, useState } from 'react';

import { programBoardList } from '@/network/apis/apiUri';
import '../../css/radio_program_intro.scss';

export default function ProgramIntro(props) {
  const { mode, pgmDetail, boardId } = props;

  const [staff, setStaff] = useState();
  const [daily, setDaily] = useState();
  const [weekly, setWeekly] = useState();
  const [weekend, setWeekend] = useState();
  const [host, setHost] = useState();

  useEffect(() => {
    programBoardList({
      board_id: boardId,
      lan_code: mode,
      page_info: {
        row_count: 10,
        number: 0,
      },
    }).then((res) => {
      if (res.status === 200) {
        const _staff = res.data.item.find((el) => /staff|스태프|스탭/gi.test(el.title));
        const _daily = res.data.item.find((el) => /daily|데일리|news/gi.test(el.title));
        const _weekly = res.data.item.find((el) => /weekly|위클리/gi.test(el.title));
        const _weekend = res.data.item.find((el) => /weekend|위켄드/gi.test(el.title));
        const _host = res.data.item.find((el) => /host|호스트/gi.test(el.title));

        if (_staff)
          setStaff({
            title: _staff.title,
            content: _staff.content?.replaceAll(/(?:\r\n|\r|\n)/g, '<br />'),
          });
        if (_daily)
          setDaily({
            title: _daily.title,
            content: _daily.content?.replaceAll(/(?:\r\n|\r|\n)/g, '<br />'),
          });
        if (_weekly)
          setWeekly({
            title: _weekly.title,
            content: _weekly.content?.replaceAll(/(?:\r\n|\r|\n)/g, '<br />'),
          });
        if (_weekend)
          setWeekend({
            title: _weekend.title,
            content: _weekend.content?.replaceAll(/(?:\r\n|\r|\n)/g, '<br />'),
          });
        if (_host)
          setHost({
            title: _host.title,
            content: _host.content?.replaceAll(/(?:\r\n|\r|\n)/g, '<br />'),
          });
      }
    });
    return () => {
      setStaff(undefined);
      setDaily(undefined);
      setWeekly(undefined);
      setWeekend(undefined);
      setHost(undefined);
    };
  }, []);

  return (
    <div id="RadioProgramIntro" className="radioProgramIntro">
      <section className="radioProgramIntro_section">
        <h2 className="radioProgramIntro_section_title">Introduction</h2>
        <div className="info">
          <p
            className="info_content"
            dangerouslySetInnerHTML={{
              __html: pgmDetail.content,
            }}
          />
        </div>
        <div className="radioProgramIntro_section_segment-wrap">
          {daily && (
            <>
              <h3 className="title">{daily.title}</h3>
              <div className="content" dangerouslySetInnerHTML={{ __html: daily.content }} />
            </>
          )}
          {weekly && (
            <>
              <h3 className="title">{weekly.title}</h3>
              <div className="content" dangerouslySetInnerHTML={{ __html: weekly.content }} />
            </>
          )}
          {weekend && (
            <>
              <h3 className="title">{weekend.title}</h3>
              <div className="content" dangerouslySetInnerHTML={{ __html: weekend.content }} />
            </>
          )}
        </div>
      </section>
      <section className="radioProgramIntro_section">
        {staff && (
          <div className="box">
            <h3 className="box_title">{staff.title}</h3>
            <dl className="box_content" dangerouslySetInnerHTML={{ __html: staff.content }} />
          </div>
        )}
        {host && (
          <div className="radioProgramIntro_section_host">
            <h3 className="title">{host.title}</h3>
            <div dangerouslySetInnerHTML={{ __html: host.content }} />
          </div>
        )}
      </section>
    </div>
  );
}
